import useSnackbar from 'hooks/useSnackbar';

const useError = (defaultMessage = 'An error occurred') => {
  const notify = useSnackbar();
  return (message = defaultMessage) =>
    notify({
      message: message.message || message,
      type: 'error',
      position: 'top-center',
      style: { marginTop: 120 },
      duration: 0,
    });
};

export default useError;
